<template lang="pug">
    .title(ref='animation' :class='color')
        .title__row(:class='[(row%2==0) ? `even` : `odd`]' :ref='[(row%2==0) ? `even` : `odd`]',  v-for='(row, rowIndex) in 3', :key='rowIndex')
            .title__item(v-for='(item, itemIndex) in 8', v-html='title', :key='`${rowIndex}-${itemIndex}`')
            
</template>
<script>
import {mixinAnimation} from './mixins/mixinAnimation';
//import * as basicScroll from 'basicscroll';
import {gsap} from 'gsap';
export default {
    data() {
        return {
            instance: null,
            isInited: false
        };
    },
    props: {
        title: String,
        color: String,
        isActive: Boolean
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline();

            gsap.set(this.$refs.odd, {x: '-30%'});
            gsap.set(this.$refs.even, {x: '0%'});

            this.timeline
                .set(this.$refs.odd, {x: '-30%'})
                .set(this.$refs.even, {x: '0%'})
                .fromTo(this.$refs.odd, {x: '-30%'}, {duration: 2, ease: 'none', x: '0%'}, 0)
                .fromTo(this.$refs.even, {x: '0%'}, {duration: 2, ease: 'none', x: '-30%'}, 0);
        }
        // createAnimation() {
        //     const instance = basicScroll.create({
        //         elem: this.$refs.title,
        //         from: 'top-bottom',
        //         to: 'bottom-top',
        //         direct: true,
        //         props: {
        //             '--translate': {
        //                 from: 0,
        //                 to: 1
        //             }
        //         }
        //     });
        //     this.instance = instance;
        //     this.instance.start();
        //     this.isInited = true;
        // },

        // destroyAnimation() {
        //     if (this.instance) {
        //         this.instance.destroy();
        //         this.instance = null;
        //     }
        //     this.isInited = false;
        // }
    }
    // watch: {
    //     isActive() {
    //         if (this.isActive) this.createAnimation();
    //         else this.destroyAnimation();
    //     }
    // },
    // mounted() {
    //     if (this.isActive) this.createAnimation();
    //     console.log('mounted');
    // },
    // updated() {
    //     if (this.isActive) this.createAnimation();
    //     console.log('updated');

    // },
    // beforeUpdate() {
    //     this.destroyAnimation();
    // }
};
</script>
<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.title {
    font-family: var(--font-accent);
    font-weight: 800;
    font-size: 4.69vw;
    line-height: 1.2;
    width: 100%;
    overflow: hidden;
    @media (--viewport-tablet) {
        font-size: 7.69vw;
    }
    &__row {
        display: flex;
        flex-wrap: no-wrap;
        width: max-content;
        // transition: transform 0.05s linear;
        // will-change: transform;

        // &.even {
        //     transform: translateX(calc(-30% + var(--translate) / 2 * 30%)) translateZ(0);
        // }
        // &.odd {
        //     transform: translateX(calc(var(--translate) / 2 * (-30%))) translateZ(0);
        // }
    }
    &__item {
        white-space: nowrap;
        padding: 0 24px;
        &:last-child {
            padding-right: 0;
        }
        &:first-child {
            padding-left: 0;
        }
        &:nth-child(2n + 1) {
            font-size: calc(4.69vw - 1px);
            @media (--viewport-tablet) {
                font-size: calc(7.69vw - 1px);
            }
            letter-spacing: 2px;
        }
    }
}
.white {
    .title {
        &__item {
            color: var(--color-black);
            &:nth-child(2n + 1) {
                color: transparent;
                /*text-shadow: 1px 0 0 var(--color-black), 1px 1px 0 var(--color-black), 0px 1px 0 var(--color-black), -1px -1px 0 var(--color-black),
                    1px -1px 0 var(--color-black), -1px 1px 0 var(--color-black), -1px 0 0 var(--color-black), 0 -1px 0 var(--color-black);
                letter-spacing: 2px;*/
                -webkit-text-stroke: 1px var(--color-black);
            }
        }
    }
}

.black {
    .title {
        &__item {
            color: var(--color-white);
            &:nth-child(2n + 1) {
                color: transparent;
                /*text-shadow: 1px 0 0 var(--color-white), 1px 1px 0 var(--color-white), 0px 1px 0 var(--color-white), -1px -1px 0 var(--color-white),
                    1px -1px 0 var(--color-white), -1px 1px 0 var(--color-white), -1px 0 0 var(--color-white), 0 -1px 0 var(--color-white);
                letter-spacing: 2px;*/
                -webkit-text-stroke: 1px var(--color-white);
            }
        }
    }
}

.color {
    .title {
        &__item {
            color: var(--color-black);
            &:nth-child(2n + 1) {
                color: transparent;
                /*text-shadow: 1px 0 0 var(--color-black), 1px 1px 0 var(--color-black), 0px 1px 0 var(--color-black), -1px -1px 0 var(--color-black),
                    1px -1px 0 var(--color-black), -1px 1px 0 var(--color-black), -1px 0 0 var(--color-black), 0 -1px 0 var(--color-black);
                letter-spacing: 2px;*/
                -webkit-text-stroke: 1px var(--color-black);
            }
        }
    }
}
</style>
